import { Toaster as HotToaster } from "react-hot-toast";

import { useSettings } from "../../context/SettingsContext";

/**
 * Centralized toast notification component using react-hot-toast.
 * Automatically adapts to dark/light mode.
 *
 * Usage:
 * 1. Import and add <Toaster /> once at the root level of your page/layout
 * 2. Use toast functions anywhere in your component:
 *    - toast.success('Success message')
 *    - toast.error('Error message')
 *    - toast.loading('Loading...')
 *    - toast('Custom message')
 *
 * @example
 * import { Toaster } from '@/components/ui/Toaster';
 * import toast from 'react-hot-toast';
 *
 * function MyPage() {
 *   return (
 *     <div>
 *       {/* Your content *\/}
 *       <Toaster />
 *     </div>
 *   );
 * }
 */
export function Toaster() {
  const { darkMode } = useSettings();

  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: darkMode ? "#1f2937" : "#fff",
          color: darkMode ? "#f3f4f6" : "#111827",
          border: darkMode ? "1px solid #374151" : "1px solid #e5e7eb",
          borderRadius: "0.75rem",
          padding: "1rem",
        },
        success: {
          iconTheme: {
            primary: "var(--brand-secondary)",
            secondary: "#fff",
          },
        },
        error: {
          iconTheme: {
            primary: "#ef4444",
            secondary: "#fff",
          },
        },
      }}
    />
  );
}
